import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { useToast } from "@/components/ui/use-toast";

interface Type {
  id: string;
  name: string;
  categoryId: string;
}

export function TypeConfig() {
  const [types, setTypes] = useState<Type[]>([
    { id: "1", name: "Metalon", categoryId: "1" },
    { id: "2", name: "Chapa Lisa", categoryId: "2" },
    { id: "3", name: "Tubo Redondo", categoryId: "3" },
  ]);
  const [newType, setNewType] = useState("");
  const [editingId, setEditingId] = useState<string | null>(null);
  const { toast } = useToast();

  const handleAdd = () => {
    if (!newType.trim()) {
      toast({
        title: "Erro",
        description: "O nome do tipo não pode estar vazio.",
        variant: "destructive",
      });
      return;
    }

    if (types.some(type => type.name.toLowerCase() === newType.toLowerCase())) {
      toast({
        title: "Erro",
        description: "Já existe um tipo com este nome.",
        variant: "destructive",
      });
      return;
    }

    setTypes([...types, { id: Date.now().toString(), name: newType, categoryId: "1" }]);
    setNewType("");
    toast({
      title: "Sucesso",
      description: "Tipo adicionado com sucesso.",
    });
  };

  const handleEdit = (id: string, newName: string) => {
    if (!newName.trim()) {
      toast({
        title: "Erro",
        description: "O nome do tipo não pode estar vazio.",
        variant: "destructive",
      });
      return;
    }

    if (types.some(type => type.name.toLowerCase() === newName.toLowerCase() && type.id !== id)) {
      toast({
        title: "Erro",
        description: "Já existe um tipo com este nome.",
        variant: "destructive",
      });
      return;
    }

    setTypes(types.map(type => 
      type.id === id ? { ...type, name: newName } : type
    ));
    setEditingId(null);
    toast({
      title: "Sucesso",
      description: "Tipo atualizado com sucesso.",
    });
  };

  const handleDelete = (id: string) => {
    setTypes(types.filter(type => type.id !== id));
    toast({
      title: "Sucesso",
      description: "Tipo removido com sucesso.",
    });
  };

  return (
    <div className="space-y-6">
      <div className="flex gap-4">
        <Input
          placeholder="Novo tipo"
          value={newType}
          onChange={(e) => setNewType(e.target.value)}
          className="max-w-sm bg-[#222831] text-white border-[#404040]"
        />
        <Button onClick={handleAdd} className="bg-[#0073B7] hover:bg-[#004080] text-white">
          <Plus className="h-4 w-4 mr-2" />
          Adicionar
        </Button>
      </div>

      <div className="bg-[#1A1F2C] rounded-md border border-[#404040]">
        <div className="divide-y divide-[#404040]">
          {types.map((type) => (
            <div key={type.id} className="p-4 flex items-center justify-between text-white hover:bg-[#222831]">
              {editingId === type.id ? (
                <Input
                  defaultValue={type.name}
                  onBlur={(e) => handleEdit(type.id, e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleEdit(type.id, e.currentTarget.value);
                    }
                  }}
                  className="max-w-sm bg-[#222831] text-white border-[#404040]"
                  autoFocus
                />
              ) : (
                <span>{type.name}</span>
              )}
              
              <div className="flex gap-2">
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => setEditingId(type.id)}
                  className="hover:bg-[#222831]"
                >
                  <Pencil className="h-4 w-4 text-[#0073B7]" />
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => handleDelete(type.id)}
                  className="hover:bg-[#222831]"
                >
                  <Trash2 className="h-4 w-4 text-[#E60026]" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}